{
  "messages": {
    "rescheduledOnce": "已重新安排一次",
    "rescheduledTwice": "已重新安排兩次",
    "rescheduledCountTimes": "已重新安排 {count} 次"
  }
}
